import constants from 'util/data/constants';

let cache = {};

const storage = localStorage || sessionStorage;

function set(key, val) {
    cache[key] = val;

    try {
        storage.setItem(key, typeof val === 'string' ? val : JSON.stringify(val));
    } catch (e) {
        // storage is disabled
    }
}

function get(key) {
    let val = cache[key];

    if (val === undefined) {
        try {
            val = storage.getItem(key);
        } catch (e) {
            // storage is disabled
        }

        if (typeof val === 'string') {
            try {
                val = JSON.parse(val);
            } catch (e) {
                // val is not an object
            }

            cache[key] = val;
        }
    }

    return val;
}

function clear() {
    cache = {};

    try {
        storage.clear();
    } catch (e) {
        // storage is disabled
    }

    // UE.init reconnects only when localStorage.env matches awsProfile.
    // sdt-core-js restored env on clear; without it, login stores tokens,
    // reloads, then immediately logs out.
    set('env', constants.awsProfile);
}

export default {
    set,
    get,
    clear
};
